import * as React from 'react';

interface Props extends Omit<React.HTMLProps<HTMLFormElement>, 'onSubmit'> {
  children: React.ReactNode;
  onSubmit: (isValid: boolean) => void;
}

const Form = ({children, onSubmit, style, ...rest}: Props) => {
  const handleSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      onSubmit((e.target as HTMLFormElement).checkValidity());
    },
    [onSubmit],
  );
  const styles_ = React.useMemo(
    () => ({backgroundColor: 'inherit', ...style}),
    [style],
  );
  return (
    <form {...rest} onSubmit={handleSubmit} style={styles_}>
      {children}
    </form>
  );
};

export default Form;
